import React from "react";

const FormField = ({
  type = "text",
  name = "",
  placeholder = "",
  value,
  onChange,
  label,
  autoComplete,
  required = false,
}) => {
  const inputId = name || label?.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm mb-1.5 font-medium text-slate-700"
        >
          {label}
        </label>
      )}
      <span
        className="flex h-12 w-full items-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm transition duration-200 focus-within:border-slate-900 focus-within:ring-2 focus-within:ring-slate-900/10"
        data-focus="false"
        data-hover="false"
      >
        <input
          id={inputId}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required={required}
          className="w-full border-0 bg-transparent p-0 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-0"
        />
      </span>
    </div>
  );
};

export default FormField;
